module.exports = __webpack_public_path__ + "static/media/HOTBOXOG_IRO_BG.319a39d2.png";